<template src="./home.html"></template>
<script>
import { mapState } from "vuex";
import Axios from "axios";
//import Doughnut from './chartjs/Doughnut';
import VueGallery from "vue-gallery";
import UpcomingEvent from "@/pages/upcomingevent/upcomingevent";
import Task from "@/pages/task/task";
import $ from "jquery";
import DriverProfilePicture from "@/pages/drivers/driverprofilepicture/driverprofilepicture";
import { Calendar } from "vue-sweet-calendar";
import "vue-sweet-calendar/dist/SweetCalendar.css";
import SetRandomColors from "@/assets/js/random_color.js";
import Swiper, { navigation } from "swiper";
import VehicleMaps from "@/pages/vehicles/vehiclemaps/vehiclemaps.vue";
import SendMessage from "@/pages/send_custom_notification/sendmessage";
import { googleMapApiKey } from "@/constants/config";
import GetcurrencySymbol from "@/assets/js/currency_sign.js";
import StatusButton from '@/components/StatusButton.vue';
var moment = require("moment");
var IntervalVar = null;
export default {
  //components:{ Doughnut},
  name: "Dashboard",
  components: {
    VueGallery,
    UpcomingEvent,
    Task,
    Calendar,
    DriverProfilePicture,
    VehicleMaps,
    SendMessage,
    StatusButton
  },
  filters: {
    date: function (data) {
      var sendDate = "N/A";
      if (data != "" && data != null) {
        sendDate = moment(data).format("DD-MM-YYYY");
      }
      return sendDate;
    },
    datetime: function (data) {
      if (data == "" || data == null) {
        return "--";
      }
      var reqdString = "";
      for (let i = 0; i < 10; i++) {
        reqdString += data[i];
      }
      var arr = reqdString.split("-");
      reqdString = arr[2] + "-" + arr[1] + "-" + arr[0];
      var reqTString = "";
      for (let i = 11; i < 16; i++) {
        reqTString += data[i];
      }
      var arr = reqTString.split(":");
      if (arr[0] >= 12) {
        reqTString = arr[0] - 12 + ":" + arr[1] + " PM";
      } else {
        reqTString = arr[0] + ":" + arr[1] + " AM";
      }
      return reqdString + " " + reqTString;
    },
  },
  data() {
    return {
      
      currency_type : GetcurrencySymbol(),
      trackingModule: false,
      showSimpleVehicleList: true,
      showSimpleAssetList: true,
      UpcomingEventListLoader: true,
      greeting: "",
      company_name: "",
      company_id: 0,
      time: "",
      text: "",
      search: "",
      fromDate: "",
      toDate: "",
      vrm: "",
      quickViewTab: "Vehicle",
      DriverSearchKey: "",
      VehicleSearchKey: "",
      AssetSearchKey: "",
      currentchat: [],
      drivers_excel_data: [],
      vehicle_excel_data: [],
      asset_excel_data: [],
      location_vehicle_excel_data: [],
      location_asset_excel_data: [],
      excel_data: [],
      unCheckVehicle: [],
      recentVehicleCheckFailure: [],
      vehicle_check_pass_excel_data: [],
      vehicle_check_warning_excel_data: [],
      vehicle_check_failed_excel_data: [],
      asset_check_pass_excel_data: [],
      asset_check_warning_excel_data: [],
      asset_check_failed_excel_data: [],
      excel_title: "",
      chatmenutoogle: false,
      todaysUrgentTaskNew: window.todaysUrgentTaskNew,
      showTableLoader: false,
      VehicleImageEndpoint: Endpoints.Vehicle.Image + "/",
      GenerateImageEndpoint: Endpoints.Helper.GenerateImage + "/",
      ImageEndpoint: Endpoints.Helper.Image + "/",

      VehicleWarningCnt: 0,
      VehicleWarningList: [],
      DashboardData: {},
      DashboardReport: {},
      DashboardReportData: {},
      UpcomingEvent: [],
      CalenderEvent: [],
      Vehicles: [],
      Assets: [],
      Drivers: [],
      VehicleCheckDueList: {},
      AssetCheckDueList: {},
      VehicleInspectionsDueList: {},
      VehicleChecks: [],
      CompanyChecks: [],
      ReportData: {},
      biglightgallery: [],
      DriverColor: [],
      ShowVehicleCheckImageModel: false,
      ShowVehicleDiv: true,
      ShowDriverDiv: false,
      GetReportData: false,
      GetAssetReportData: false,
      gindex: 1,
      VehicleCheckStatsData: [],
      VehicleCheckStatsList: [],
      AssetCheckStatsData: [],
      AssetCheckStatsList: [],
      galleryoptions: {
        prevClass: "prev",
        nextClass: "next",
      },

      donutchart: {
        series: [44, 55],
        chartOptions: {
          chart: {
            type: "donut",
          },
          labels: ["COMPLETE", "INCOMPLETE"],
          legend: {
            position: "bottom",
          },
          colors: ["#7366ff", "#f73164", "#51bb25", "#a927f9", "#f8d62b"],
        },
      },

      ShowVehicleNotesModel: false,
      VehicleNotes: "",
      ShowDashboardDetailPopup: false,
      ShowRectificationPopup: false,
      vehiclesafeList: false,
      vehiclewarningList: false,
      vehicleunsafeList: false,
      driverfitList: false,
      driverunfitList: false,
      vehicleLoop: true,
      DashboardDetailHeading: "",
      EventCategories: [
        {
          id: 1,
          title: "Personal",
          textColor: "white",
          backgroundColor: "#f8d62b",
          cursor: "pointer",
        },
        {
          id: 2,
          title: "Company-wide",
          textColor: "white",
          backgroundColor: "#dc3545",
          cursor: "pointer",
        },
        {
          id: 3,
          title: "National",
          textColor: "white",
          backgroundColor: "green",
          cursor: "pointer",
        },
      ],
      InspectionsChecksHeader: "Vehicle Check Stats",
      InspectionsPopupHeading: "Rectified List",
      hgvModule: false,
      VehicleInspections: [],
      CompanyInspections: [],
      LastOneMonthInspections: [],
      RectificationList: [],
      InspectionReportData: {},
      InspectionTotals: [],
      VehicleInspectionHeading: "",
      VehicleInspectionState: "",
      VehicleInspectionArr: [],
      searchVrm: 0,
      inspectionVrm: [],

      LastVehiclePosition: {},
      center: {
        lat: 55.232753,
        lng: -3.944403,
      },
      locationMarkers: [],

      infoPosition: null,
      infoOpened: false,
      infoCurrentKey: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35,
        },
        content: "",
      },

      LastVehiclePositionPopup: {},
      ShowVehiclePositionModel: false,
      centerPopup: {
        lat: 55.232753,
        lng: -3.944403,
      },
      locationMarkersPopup: [],
      ShowUrgentTask: false,
      ShowVehicleChecks: false,
      ShowAssetChecks: false,
      ShowVehicleInspections: false,
      ShowVehicle: false,
      ShowVehicleView: false,
      ShowDriver: false,
      ShowVehicleTracking: false,
      ShowDriverView: false,
      lastUpdatedPosition: "",
      SelectedDrivers:[],
      NotificationHeading:"All Drivers",
      SelectedUserLinkedDrivers:[],
      ShowNotifications: false,
      assetsModule: false,
      VehicleChecksLoader: false,
      AssetChecksLoader: false,
      
      AssetChecks: [],
      AssetReportData: {},
    };
  },
  computed: {},
  mounted() {
    var AccountPermissions = JSON.parse(localStorage.getItem("AccountPermissions"));
    var FleetSubscription = JSON.parse(localStorage.getItem("FleetSubscription"));
    var FleetSubscriptionModules = JSON.parse(FleetSubscription.fleet_modules);

    if (AccountPermissions && AccountPermissions["Vehicle Checks"] && AccountPermissions["Vehicle Checks"]["enable"]) {
      this.ShowVehicleChecks = true;
      if (AccountPermissions["Vehicle Checks"]["view_urgent_task"]) {
        this.ShowUrgentTask = true;
      }
    }
    if (AccountPermissions && AccountPermissions["Assets"] && AccountPermissions["Assets"]["enable"]) {
      this.ShowAssetChecks = true;
    }
    if (AccountPermissions && AccountPermissions["HGV"] && AccountPermissions["HGV"]["enable"]) {
      //this.ShowVehicleInspections = true;
    }
    if (AccountPermissions && AccountPermissions["Vehicle Tracking"] && AccountPermissions["Vehicle Tracking"]["enable"]
    ) {
      this.ShowVehicleTracking = true;
    }

    if (AccountPermissions && AccountPermissions.Vehicle && AccountPermissions.Vehicle.enable) {
      this.ShowVehicle = true;
      if (AccountPermissions.Vehicle.view) {
        this.ShowVehicleView = true;
      }
    }

    if (AccountPermissions && AccountPermissions.Driver && AccountPermissions.Driver.enable) {
      this.ShowDriver = true;
      if (AccountPermissions.Driver.view) {
        this.ShowDriverView = true;
      }
    }

    const isAssets = FleetSubscriptionModules["Assets"];
    if (isAssets) {
        this.assetsModule = true;
    }

    this.ShowNotifications = (FleetSubscriptionModules["Notifications"]);

    if (!FleetSubscriptionModules["Hierarchy System"]) {
      this.ShowUrgentTask = true;
      this.ShowVehicleChecks = true;
      this.ShowAssetChecks = true;
      //this.ShowVehicleInspections = true;
      this.ShowVehicle = true;
      this.ShowDriver = true;
      this.ShowVehicleTracking = true;
      this.ShowVehicleView = true;
      this.ShowDriverView = true;
    }
    var Company = JSON.parse(localStorage.getItem("Company"));
    if (Company && Company.name) {
      this.company_name = Company.name;
      this.company_id = Company.id;
      if(window.taskModuleCompanies.includes(this.company_id)){
      	this.todaysUrgentTaskNew = true
      }
    }  

    this.GetDashBoardReport();
    //this.GetUpcomingEventList();
    if(this.todaysUrgentTaskNew){
    	this.GetUpcomingTaskList();
    }else{
    	if (typeof this.GetUpcomingEventListVehicle === 'function') {
    		this.GetUpcomingEventListVehicle();
    	}
    }
    
    this.GetVehicleCheckStats();
    setTimeout(() => {
       if(this.assetsModule && this.ShowAssetChecks){
        this.GetAssetCheckStats();
        this.GetAssetChecksDueList();
      }
    }, 1000);
   
    this.GetDriversList();
    this.GetVehicleChecksDueList();
    //this.GetVehicleChecksList();
    this.GetCompanySubscription();    
    $("#sweetCalendar").on("click", ".left-arrow", function (event) {
    	$(".task-calendar-refresh").trigger('click');
    })

    $("#sweetCalendar").on("click", ".right-arrow", function (event) {
    	$(".task-calendar-refresh").trigger('click');
    })

    $("#sweetCalendar").on("click", "div.day", function (event) {
      let MonthNames = {
        January: 0,
        February: 1,
        March: 2,
        April: 3,
        May: 4,
        June: 5,
        July: 6,
        August: 7,
        September: 8,
        October: 9,
        November: 10,
        December: 11,
      };      
      var day = this.innerText;
      var montharr = $("#sweetCalendar div.month").html().split(" ");
      var month = MonthNames[montharr[0]];
      var year = montharr[1];
      let clickedDate = new Date(year, month, day, 8, 0, 0)
        .toISOString()
        .slice(0, 10);              
      
      $("tr.eventdaylist").hide();
      if ($("tr.eventdaylist_" + clickedDate).length > 0) {
        $("tr.eventdaylist_" + clickedDate).show();
        $("#DateCalenderEventDayWise h5.modal-title").html(
          "Event list For " +
            day.toString().padStart(2, "0") +
            "-" +
            (month + 1).toString().padStart(2, "0") +
            "-" +
            year
        );
        $("#DateCalenderEventDayWise").show();
        $("#DateCalenderEventDayWiseOverlay").show();
      }
    });

    $(".closedaywise").on("click", function (event) {
      $("#DateCalenderEventDayWise").hide();
      $("#DateCalenderEventDayWiseOverlay").hide();
    });
    $(".closeDashboardDetail").on("click", function (event) {
      $("#DashboardDetailPopup").hide();
      $("#DateCalenderEventDayWiseOverlay").hide();
    });
  },
  methods: {
    messageSent() {
      this.SelectedDrivers = [];
    },
    setNotificationToAllDriver(){
      this.SelectedDrivers = this.SelectedUserLinkedDrivers;
      this.NotificationHeading = "All Drivers";
    },
    setDriver(driverID, driverName){
      this.SelectedDrivers = [];
      this.SelectedDrivers.push(driverID);
      this.NotificationHeading = driverName;
    },
    exportActionNeeded() {
      this.$refs.upcoming_events.exportActionNeeded();
    },
    exportUrgentTask() {
      this.$refs.urgent_task.exportActionNeeded();
    },
    selectQuickView(type) {
      this.quickViewTab = type;
    },
    showInspectionsList(title) {
      this.VehicleInspectionArr = [];
      this.VehicleInspectionHeading = title;
      this.VehicleInspectionState = title;
      if (
        typeof this.InspectionReportData.vehicles != "undefined" &&
        typeof this.InspectionReportData.vehicles[title] != "undefined"
      ) {
        this.VehicleInspectionArr = this.InspectionReportData.vehicles[title];
      }
    },
    GetCompanySubscription() {
      var FleetSubscriptionModules = JSON.parse(
        JSON.parse(localStorage.getItem("FleetSubscription")).fleet_modules
      );
      const isHGV = FleetSubscriptionModules.HGV;
      const isTracking = FleetSubscriptionModules["Vehicle Tracking"];
      const isVehicle = FleetSubscriptionModules["Vehicle"];

      if (isHGV && enableVehicleInspection) {
        this.hgvModule = true;
        $(".inspections-checks .nav-pills").css({
          display: "flex",
        });
        this.GetVehicleInspectionsDueList();
        this.GetVehicleInspectionsList();
      }
      if(isVehicle){
        if (isTracking) {
          this.trackingModule = true;
          this.showSimpleVehicleList = false;
          this.showSimpleAssetList = false;
          this.ShowVehiclePosition();
        } else {
          this.GetVehiclesList();
          this.GetAssetsList();
        }
      }
    },
    GetDashBoardReport() {
      Axios.post(Endpoints.Dashboard.DashboardReport, {
        token: localStorage.getItem("token"),
        type: "all",
      }).then((Response) => {
        if (Response?.data?.success) {
          this.DashboardReport = Response.data.DashboardReport;
        }
      });
    },
    GetUpcomingEventList(type = null) {
      Axios.post(Endpoints.Dashboard.UpcomingEvent, {
        token: localStorage.getItem("token"),
        RequestFor: "Home",
        Source: type,
      }).then((Response) => {
        if (Response?.data?.success) {
          this.UpcomingEvent = Response.data.upcoming_event;
          this.CalenderEvent = Response.data.calender_event;
          this.VehicleWarningCnt = 0;
          var VehicleWarningArr = [];
          var VehicleWarningList = [];
          for (var i = 0; i < this.UpcomingEvent.length; i++) {
            if (
              (this.UpcomingEvent[i]["type"] == "vehicle" ||
                this.UpcomingEvent[i]["type"] == "vehiclecheck") &&
              (this.UpcomingEvent[i]["status"] == "yellow" ||
                this.UpcomingEvent[i]["status"] == "orange")
            ) {
              //this.VehicleWarningCnt = this.VehicleWarningCnt + 1;
              VehicleWarningArr[this.UpcomingEvent[i]["vrm"]] =
                this.UpcomingEvent[i]["vrm"];
              VehicleWarningList.push(this.UpcomingEvent[i]);
            }
          }
          this.VehicleWarningList = VehicleWarningList.sort(function (a, b) {
            return a["vrm"].localeCompare(b["vrm"]);
          });
          this.VehicleWarningCnt = Object.keys(VehicleWarningArr).length;
        }
        this.UpcomingEventListLoader = false;
      });
    },
    SetUpcomingTaskData(data, sorting = false) {
      if (data.upcoming_task && data.upcoming_task.length > 0) {
        data.upcoming_task.forEach((element, index) => {
          this.UpcomingEvent.push(element);
        });
        data.upcoming_task.forEach((element, index) => {
          this.CalenderEvent.push(element);
        }); 
      }
            

      if (this.UpcomingEvent.length > 0) {
        this.UpcomingEvent.forEach((element) => {
          if (element.type == "vehiclecheck" && element.status == "red") {
            var obj = {};
            obj["VRM"] = element.vrm;
            obj["Driver"] = element.driver;
            obj["Date"] = element.date;
            obj["Check"] = element.event_name;
            this.recentVehicleCheckFailure.push(obj);
          }
        });
      }      

      if (this.UpcomingEvent.length > 0 && sorting) {
        this.UpcomingEvent.sort((a, b) => a.date3 - b.date3);
        const expired = this.UpcomingEvent.filter(
          (event) => event.status == "red"
        );
        const warning = this.UpcomingEvent.filter(
          (event) => event.status == "yellow"
        );
        const upcoming = this.UpcomingEvent.filter(
          (event) => event.status == "orange"
        );
        this.UpcomingEvent = [...expired, ...warning, ...upcoming];

        this.VehicleWarningCnt = 0;
        var VehicleWarningArr = [];
        var VehicleWarningList = [];
        for (var i = 0; i < this.UpcomingEvent.length; i++) {
          if (
            (this.UpcomingEvent[i]["type"] == "vehicle" ||
              this.UpcomingEvent[i]["type"] == "vehiclecheck") &&
            (this.UpcomingEvent[i]["status"] == "yellow" ||
              this.UpcomingEvent[i]["status"] == "orange")
          ) {
            //this.VehicleWarningCnt = this.VehicleWarningCnt + 1;
            VehicleWarningArr[this.UpcomingEvent[i]["vrm"]] =
              this.UpcomingEvent[i]["vrm"];
            VehicleWarningList.push(this.UpcomingEvent[i]);
          }
        }
        this.VehicleWarningList = VehicleWarningList.sort(function (a, b) {
          return a["vrm"].localeCompare(b["vrm"]);
        });
        this.VehicleWarningCnt = Object.keys(VehicleWarningArr).length;
      }

      // console.log('UpcomingEvent',this.UpcomingEvent)     
      // console.log('CalenderEvent',this.CalenderEvent)     
    },
    GetUpcomingTaskList() {
    	let MonthNames = {
	        January: 0,
	        February: 1,
	        March: 2,
	        April: 3,
	        May: 4,
	        June: 5,
	        July: 6,
	        August: 7,
	        September: 8,
	        October: 9,
	        November: 10,
	        December: 11,
        };
    	var montharr = $("#sweetCalendar div.month").html().split(" ");
      	var month = MonthNames[montharr[0]];
      	var year = montharr[1];
      	let startDate = new Date(year, month, 1, 8, 0, 0).toISOString().slice(0, 10);
      	let endDate = new Date(year, month+1, 1, 8, 0, 0).toISOString().slice(0, 10);

      this.UpcomingEvent=[];	
      this.CalenderEvent=[];	
      this.UpcomingEventListLoader = true;
      Axios.post(Endpoints.Task.GET_LIST, {
        token: localStorage.getItem("token"),
        RequestFor: "Home",
        SearchType: "ByDate",
        startDate: startDate,
        endDate: endDate,
      }).then((Response) => {        
        if (Response?.data?.success) {          
          this.SetUpcomingTaskData(Response.data);
          this.UpcomingEventListLoader = false;
        }
      });
    },
    SetUpcomingEventListData(data, sorting = false) {
      data.upcoming_event.forEach((element, index) => {
        this.UpcomingEvent.push(element);
      });
      data.calender_event.forEach((element, index) => {
        this.CalenderEvent.push(element);
      });      

      if (this.UpcomingEvent.length > 0) {
        this.UpcomingEvent.forEach((element) => {
          if (element.type == "vehiclecheck" && element.status == "red") {
            var obj = {};
            obj["VRM"] = element.vrm;
            obj["Driver"] = element.driver;
            obj["Date"] = element.date;
            obj["Check"] = element.event_name;
            this.recentVehicleCheckFailure.push(obj);
          }
        });
      }      

      if (sorting) {
        this.UpcomingEvent.sort((a, b) => a.date3 - b.date3);
        const expired = this.UpcomingEvent.filter(
          (event) => event.status == "red"
        );
        const warning = this.UpcomingEvent.filter(
          (event) => event.status == "yellow"
        );
        const upcoming = this.UpcomingEvent.filter(
          (event) => event.status == "orange"
        );
        this.UpcomingEvent = [...expired, ...warning, ...upcoming];

        this.VehicleWarningCnt = 0;
        var VehicleWarningArr = [];
        var VehicleWarningList = [];
        for (var i = 0; i < this.UpcomingEvent.length; i++) {
          if (
            (this.UpcomingEvent[i]["type"] == "vehicle" ||
              this.UpcomingEvent[i]["type"] == "vehiclecheck") &&
            (this.UpcomingEvent[i]["status"] == "yellow" ||
              this.UpcomingEvent[i]["status"] == "orange")
          ) {
            //this.VehicleWarningCnt = this.VehicleWarningCnt + 1;
            VehicleWarningArr[this.UpcomingEvent[i]["vrm"]] =
              this.UpcomingEvent[i]["vrm"];
            VehicleWarningList.push(this.UpcomingEvent[i]);
          }
        }
        this.VehicleWarningList = VehicleWarningList.sort(function (a, b) {
          return a["vrm"].localeCompare(b["vrm"]);
        });
        this.VehicleWarningCnt = Object.keys(VehicleWarningArr).length;
      }
    },    
    GetUpcomingEventListVehicle() {
      this.UpcomingEvent=[];	
      this.CalenderEvent=[];	
      this.UpcomingEventListLoader = true;
      Axios.post(Endpoints.Dashboard.UpcomingEventVehicle, {
        token: localStorage.getItem("token"),
        RequestFor: "Home",
      }).then((Response) => {        
        if (Response?.data?.success) {
          this.GetUpcomingEventListVehicleChecks();
          this.SetUpcomingEventListData(Response.data);
        }
      });
    },
    GetUpcomingEventListVehicleChecks() {
      Axios.post(Endpoints.Dashboard.UpcomingEventVehicleChecks, {
        token: localStorage.getItem("token"),
        RequestFor: "Home",
      }).then((Response) => {
        if (Response?.data?.success) {
          this.GetUpcomingEventListVehicleDocuments();
          this.SetUpcomingEventListData(Response.data);
        }
      });
    },
    GetUpcomingEventListVehicleDocuments() {
      Axios.post(Endpoints.Dashboard.UpcomingEventDocuments, {
        token: localStorage.getItem("token"),
        RequestFor: "Home",
      }).then((Response) => {
        if (Response?.data?.success) {
          this.GetUpcomingEventListVehicleDrivers();
          this.SetUpcomingEventListData(Response.data);
        }
      });
    },
    GetUpcomingEventListVehicleDrivers() {
      Axios.post(Endpoints.Dashboard.UpcomingEventDrivers, {
        token: localStorage.getItem("token"),
        RequestFor: "Home",
      }).then((Response) => {
        if (Response?.data?.success) {
        	if (this.assetsModule) {            
            	this.GetUpcomingEventListAssets();
        	}

            this.GetUpcomingEventListRepair();            
        	this.GetUpcomingEventListManualTask();
          	this.SetUpcomingEventListData(Response.data, true);
        }
      });
    },
    GetUpcomingEventListAssets() {
      var obj = { token: localStorage.getItem("token") };
      obj.RequestFor= "Home";
      Axios.post(Endpoints.Dashboard.UpcomingEventAssets, obj).then((Response) => {
        if (Response?.data?.success) {
            this.SetUpcomingEventListData(Response.data, true);
        }
      });
    },
    GetUpcomingEventListRepair() {
      var obj = { token: localStorage.getItem("token") };
      obj.RequestFor= "Home";      
      Axios.post(Endpoints.Dashboard.UpcomingEventRepair, obj).then((Response) => {
        if (Response?.data?.success) {
            this.SetUpcomingEventListData(Response.data, true);
        }
      });
    },
    GetUpcomingEventListManualTask() {
      var obj = { token: localStorage.getItem("token") };
      obj.RequestFor= "Home";      
      Axios.post(Endpoints.Dashboard.UpcomingEventManualTask, obj).then((Response) => {
        if (Response?.data?.success) {          	
            this.SetUpcomingEventListData(Response.data, true);
        }
        this.UpcomingEventListLoader = false;
      });
    },
    DownloadDocument(file) {
      window.open(this.ImageEndpoint + file, "_blank");
    },
    SearchVehicle() {
      this.GetVehiclesList("search");
    },
    GetVehiclesList(type = "") {
      var obj = { token: localStorage.getItem("token") };
      if (type == "search") {
        obj.searchkey = this.VehicleSearchKey;
      }
      Axios.post(Endpoints.Vehicle.ListPlain, obj).then((Response) => {
        if (Response?.data?.success) {
          this.Vehicles = Response.data.vehicles;
          this.vehicle_excel_data = [];
          if (this.Vehicles.length > 0) {
            this.Vehicles.forEach((element2) => {
              var obj = {};
              obj["VRM"] = element2.vrm;
              obj["Make"] = element2.make;
              obj["Model"] = element2.model;
              this.vehicle_excel_data.push(obj);
            });
          }
        }
      });
    },
    SearchAssets() {
      this.GetAssetsList("search");
    },
    GetAssetsList(type = "") {
      var obj = { token: localStorage.getItem("token") };
      if (type == "search") {
        obj.name = this.AssetSearchKey;
        //obj.searchkey = this.AssetSearchKey;
      }
      Axios.post(Endpoints.Assets.List, obj).then((Response) => {
        if (Response?.data?.success) {        	
          this.Assets = Response.data.AssetsList;
          this.asset_excel_data = [];
          if (this.Assets.length > 0) {
            this.Assets.forEach((element2) => {
              var obj = {};
              obj["Name"] = element2.name;
              obj["Make"] = element2.make;
              obj["Model"] = element2.model;
              this.asset_excel_data.push(obj);
            });
          }
        }
      });
    },
    SearchDriver() {
      this.GetDriversList("search");
    },
    GetDriversList(type = "") {
      var obj = { token: localStorage.getItem("token") };
      if (type == "search") {
        obj.searchkey = this.DriverSearchKey;
      }
      Axios.post(Endpoints.Driver.List, obj).then((Response) => {
        if (Response?.data?.success) {
          this.Drivers = Response.data.drivers;
          this.drivers_excel_data = [];
          if (this.Drivers.length > 0) {
            this.Drivers.forEach((element2) => {
              var obj = {};
              obj["Driver"] = element2.forename + " " + element2.surname;
              this.drivers_excel_data.push(obj);
            });
          }

          /* set random color for driver profile pic */
          this.DriverColor = SetRandomColors(this.Drivers);
          /****************************************/
        }
      });
    },
    GetVehicleChecksDueList() {
      Axios.post(Endpoints.Dashboard.VehicleCheckDueList, {
        token: localStorage.getItem("token"),
      }).then((Response) => {
        if (Response?.data?.success) {
          this.VehicleCheckDueList = Response.data.VehicleCheckDueList;
          this.unCheckVehicle = [];
          this.SelectedUserLinkedDrivers = [];
          if (this.VehicleCheckDueList.length > 0) {
            this.VehicleCheckDueList.forEach((element) => {
              var obj = {};
              obj["VRM"] = element.vrm;
              obj["Driver"] = element.driver;
              obj["Last Checked"] = element.check_due;
              this.unCheckVehicle.push(obj);
              if(element.driver_linked && element.driver_id > 0 && !this.SelectedUserLinkedDrivers.includes(element.driver_id)){
                this.SelectedUserLinkedDrivers.push(element.driver_id);
              }
            });
          }
        }
      });
    },
    
    GetAssetChecksDueList() {
      Axios.post(Endpoints.Dashboard.AssetCheckDueList, {
        token: localStorage.getItem("token"),
      }).then((Response) => {
        if (Response?.data?.success) {
          this.AssetCheckDueList = Response.data.AssetCheckDueList;
          this.unCheckVehicle = [];
          if (this.AssetCheckDueList.length > 0) {
            this.AssetCheckDueList.forEach((element) => {
              var obj = {};
              obj["Name"] = element.name; 
              obj["Driver"] = element.driver;
              obj["Last Checked"] = element.check_due;
              this.unCheckVehicle.push(obj);
            });
          }
        }
      });
    },
    GetVehicleInspectionsDueList() {
      Axios.post(Endpoints.Dashboard.VehicleInspectionsDueList, {
        token: localStorage.getItem("token"),
      }).then((Response) => {
        if (Response?.data?.success) {
          this.VehicleInspectionsDueList =
            Response.data.VehicleInspectionDueList;
        }
      });
    },
    SearchVehicleInspections() {
      this.GetVehicleInspectionsList("search");
    },
    GetLastOneMonthInspectionsList() {
      var obj = { token: localStorage.getItem("token") };
      Axios.post(Endpoints.Dashboard.VehicleInspectionsLastOneMonth, obj).then(
        (Response) => {
          if (Response?.data?.success) {
            this.LastOneMonthInspections = Response.data.inspections;

            if (this.LastOneMonthInspections.length == 1) {
              this.vehicleLoop = false;
            }
            setTimeout(() => {
              new Swiper(".swiper", {
                // Optional parameters
                direction: "horizontal",
                loop: this.vehicleLoop,
                // Navigation arrows
                navigation: {
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                },
              });
            }, 1000);
          }
        }
      );
    },
    GetVehicleInspectionsList(type) {
      var obj = { token: localStorage.getItem("token") };
      var dt = new Date();
      obj.fromDate = dt.getFullYear() + "-01-01";
      obj.toDate =
        dt.getFullYear() + "-" + (dt.getMonth() + 1) + "-" + dt.getDate();
      if (type == "search") {
        obj.vrm = this.searchVrm;
      }
      Axios.post(Endpoints.VehicleInspections.VehicleInspectionsList, obj).then(
        (Response) => {
          if (Response?.data?.success) {
            this.VehicleInspections = Response.data.FleetInspectionSubmit;
            this.CompanyInspections = Response.data.CompanyInspections;
            this.InspectionReportData = Response.data.ReportData;
            this.inspectionVrm = Response.data.ReportData.vrms;
            if (
              typeof this.InspectionReportData.total != "undefined" &&
              type != "search"
            ) {
              Object.keys(Response.data.ReportData.total).forEach(
                (element, index) => {
                  var icon = "ban";
                  var color = "secondary";
                  if (index == 1) {
                    icon = "exclamation-triangle";
                    color = "warning";
                  } else if (index == 2) {
                    icon = "ban";
                    color = "secondary";
                  } else if (index == 3) {
                    icon = "square-xmark";
                    color = "danger";
                  } else if (index == 4) {
                    icon = "desktop";
                    color = "primary";
                  }
                  this.InspectionTotals.push({
                    title: element,
                    total: Response.data.ReportData.total[element],
                    icon: icon,
                    color: color,
                  });
                }
              );
            }
            if (type == "search") {
              this.showInspectionsList(this.VehicleInspectionHeading);
            }
          }
        }
      );
    },
    GetVehicleChecksList(type = "") {
      if(!this.GetReportData){
        var obj = { token: localStorage.getItem("token") };
        var dt = new Date();
        obj.fromDate =
          dt.getFullYear() + "-" + (dt.getMonth() + 1) + "-" + dt.getDate();
        obj.toDate =
          dt.getFullYear() + "-" + (dt.getMonth() + 1) + "-" + dt.getDate();
        if (type == "search") {
          obj.vrm = this.vrm;
          obj.fromDate = this.fromDate;
          obj.toDate = this.toDate;
        }else{
          obj.type = this.type;
        }
        obj.withReport = true;
        this.VehicleChecksLoader = true;
        Axios.post(Endpoints.VehicleChecks.VehicleChecksList, obj).then(
          (Response) => {
            this.VehicleChecksLoader = false;          
            if (Response?.data?.success) {
              this.GetReportData = true;
              this.VehicleChecks = Response.data.FleetCheckSubmit;
              this.CompanyChecks = Response.data.CompanyChecks;
              //this.SetVehicleChecksExcelData();
              this.ReportData = Response.data.ReportData;

              this.vehicle_check_pass_excel_data = [];
              if (this.ReportData.PassedDetailedArr.length > 0) {
                this.ReportData.PassedDetailedArr.forEach((element) => {
                  var obj = {};
                  obj["Vehicle"] = element.vrm;
                  obj["Status"] = "Pass";
                  this.vehicle_check_pass_excel_data.push(obj);
                });
              }
              this.vehicle_check_warning_excel_data = [];
              if (this.ReportData.PassedWithWarningArrFull.length > 0) {
                this.ReportData.PassedWithWarningArrFull.forEach((element2) => {
                  var obj = {};
                  obj["Vehicle"] = element2.vrm;
                  obj["Reason"] = element2.reason;
                  obj["Status"] = "Warning";
                  this.vehicle_check_warning_excel_data.push(obj);
                });
              }
              this.vehicle_check_failed_excel_data = [];
              if (this.ReportData.FailedArrFull.length > 0) {
                this.ReportData.FailedArrFull.forEach((element3) => {
                  var obj = {};
                  obj["Vehicle"] = element3.vrm;
                  obj["Reason"] = element3.reason;
                  obj["Status"] = "Failed";
                  this.vehicle_check_failed_excel_data.push(obj);
                });
              }
              
            }
          }
        );
      }
    },
    GetAssetChecksList(type = "") {
      if(!this.GetAssetReportData){
        var obj = { token: localStorage.getItem("token") };
        var dt = new Date();
        obj.fromDate =
          dt.getFullYear() + "-" + (dt.getMonth() + 1) + "-" + dt.getDate();
        obj.toDate =
          dt.getFullYear() + "-" + (dt.getMonth() + 1) + "-" + dt.getDate();
        if (type == "search") {
          obj.vrm = this.vrm;
          obj.fromDate = this.fromDate;
          obj.toDate = this.toDate;
        }else{
          obj.type = this.type;
        }
        obj.withReport = true;
        this.AssetChecksLoader = true;
        Axios.post(Endpoints.Assets.Checks.List, obj).then(
          (Response) => {
            this.AssetChecksLoader = false;          
            if (Response?.data?.success) {
              this.GetAssetReportData = true;
              this.AssetChecks = Response.data.FleetCheckSubmit;
              this.AssetReportData = Response.data.ReportData;

              this.asset_check_pass_excel_data = [];
              if (this.AssetReportData.PassedDetailedArr.length > 0) {
                this.AssetReportData.PassedDetailedArr.forEach((element) => {
                  var obj = {};
                  obj["Asset"] = element.serial_number;
                  obj["Status"] = "Pass";
                  this.asset_check_pass_excel_data.push(obj);
                });
              }
              this.asset_check_warning_excel_data = [];
              if (this.AssetReportData.PassedWithWarningArrFull.length > 0) {
                this.AssetReportData.PassedWithWarningArrFull.forEach((element2) => {
                  var obj = {};
                  obj["Asset"] = element2.serial_number;
                  obj["Reason"] = element2.reason;
                  obj["Status"] = "Warning";
                  this.asset_check_warning_excel_data.push(obj);
                });
              }
              this.asset_check_failed_excel_data = [];
              if (this.AssetReportData.FailedArrFull.length > 0) {
                this.AssetReportData.FailedArrFull.forEach((element3) => {
                  var obj = {};
                  obj["Asset"] = element3.serial_number;
                  obj["Reason"] = element3.reason;
                  obj["Status"] = "Failed";
                  this.asset_check_failed_excel_data.push(obj);
                });
              }
              
            }
          }
        );
      }
    },

    GetVehicleCheckStats() {
      var obj = { token: localStorage.getItem("token") };
      var dt = new Date();
      obj.fromDate =
        dt.getFullYear() + "-" + (dt.getMonth() + 1) + "-" + dt.getDate();
      obj.toDate =
        dt.getFullYear() + "-" + (dt.getMonth() + 1) + "-" + dt.getDate();
      this.ShowLoader = true;
      Axios.post(Endpoints.VehicleChecks.VehicleCheckStats, obj).then(
        (Response) => {
          this.ShowLoader = false;
          if (Response?.data?.success) {
            this.VehicleCheckStatsData = Response.data.ReportData;
          }
        }
      );
    },
     GetAssetCheckStats() {
      var obj = { token: localStorage.getItem("token") };
      var dt = new Date();
      obj.fromDate =
        dt.getFullYear() + "-" + (dt.getMonth() + 1) + "-" + dt.getDate();
      obj.toDate =
        dt.getFullYear() + "-" + (dt.getMonth() + 1) + "-" + dt.getDate();
      this.ShowLoader = true;
      Axios.post(Endpoints.Assets.Checks.AssetCheckStats, obj).then(
        (Response) => {
          this.ShowLoader = false;
          if (Response?.data?.success) {
            this.AssetCheckStatsData = Response.data.ReportData;
          }
        }
      );
    },
    ShowVehicleImage(VehicleCheck) {
      this.ShowVehicleCheckImageModel = true;
      this.lightgallery = JSON.parse(JSON.stringify(VehicleCheck.photo));
      this.biglightgallery = JSON.parse(JSON.stringify(VehicleCheck.photo));
      for (var i = 0; i < this.biglightgallery.length; i++) {
        this.biglightgallery[i] = this.ImageEndpoint + this.biglightgallery[i];
      }
    },
    ShowVehicleDriverDiv(type) {
      if (type == "vehicles") {
        this.ShowVehicleDiv = true;
        this.ShowDriverDiv = false;
      }
      if (type == "drivers") {
        this.ShowVehicleDiv = false;
        this.ShowDriverDiv = true;
      }
    },
    ShowVehicleNotes(VehicleCheck, type = "notes") {
      this.ShowVehicleNotesModel = true;
      this.VehicleNotes = VehicleCheck.notes;
    },
    ShowInspectionDetail(id, type) {
      this.ShowRectificationPopup = true;
      this.InspectionsPopupHeading = "Rectified List";
      if (type == 5) {
        this.InspectionsPopupHeading = "Monitor Inspections List";
      }
      var obj = {
        token: localStorage.getItem("token"),
        inspection_id: id,
        type: type,
      };
      Axios.post(Endpoints.Dashboard.VehicleInspectionRectifications, obj).then(
        (Response) => {
          if (Response?.data?.success) {
            this.RectificationList = Response.data.rectifications;
          }
        }
      );
    },
    ShowDashboardReportDetail(type) {
      this.driverfitList = false;
      this.driverunfitList = false;
      this.vehiclesafeList = false;
      this.vehicleunsafeList = false;
      this.vehiclewarningList = false;
      this.assetsafeList = false;
      this.assetunsafeList = false;
      this.assetwarningList = false;
      this.showTableLoader = true;

      if (type == "driverfit") {
        this.DashboardReportData.FitDriverArr = [];
        this.DashboardDetailHeading = "Authorised To Drive Driver List";
        this.driverfitList = true;
      }
      if (type == "driverunfit") {
        this.DashboardReportData.UnfitDriverArr = [];
        this.DashboardDetailHeading = "Unauthorised To Drive Driver List";
        this.driverunfitList = true;
      }
      if (type == "vehiclesafe") {
        this.DashboardReportData.VehicleSafeArr = [];
        this.DashboardDetailHeading = "Safe To Drive Vehicle List";
        this.vehiclesafeList = true;
      }
      if (type == "vehicleunsafe") {
        this.DashboardReportData.VehicleUnSafeArr = [];
        this.DashboardDetailHeading = "Un-Safe To Drive Vehicle List";
        this.vehicleunsafeList = true;
      }
      if (type == "vehiclewarning") {
        this.DashboardReportData.VehicleWarningArr = [];
        this.DashboardDetailHeading = "Warning Vehicle List";
        this.vehiclewarningList = true;
      }
      if (type == "assetsafe") {
        this.DashboardReportData.AssetSafeArr = [];
        this.DashboardDetailHeading = "Safe To Assets List";
        this.assetsafeList = true;
      }
      if (type == "assetunsafe") {
        this.DashboardReportData.AssetUnSafeArr = [];
        this.DashboardDetailHeading = "Un-Safe Assets List";
        this.assetunsafeList = true;
      }
      if (type == "assetwarning") {
        this.DashboardReportData.AssetWarningArr = [];
        this.DashboardDetailHeading = "Warning Assets List";
        this.assetwarningList = true;
      }
      this.ShowDashboardDetailPopup = true;      

      var obj = {
        token: localStorage.getItem("token"),
        type: type,
      }
      if (type == "assetsafe") {
      	obj.type='safe'
      	obj.item_type='AssetsList'
      }else if (type == "assetunsafe") {
      	obj.type='unsafe'
      	obj.item_type='AssetsList'
      }
      else if (type == "assetwarning") {
      	obj.type='warning'
      	obj.item_type='AssetsList'
      }

      Axios.post(Endpoints.Dashboard.DashboardReportData, obj).then((Response) => {
        if (Response?.data?.success) {
          this.DashboardReportData = Response.data.DashboardReportData;
          this.showTableLoader = false;
          this.excel_data = [];
          if (type == "vehiclesafe") {
            if (this.DashboardReportData.VehicleSafeArr.length > 0) {
              this.DashboardReportData.VehicleSafeArr.forEach((element) => {
                var obj = {};
                obj["Vehicle"] = element.vrm;
                if (element?.driver?.driver?.forename) {
                  obj["Driver"] =
                    element.driver.driver.forename +
                    " " +
                    element.driver.driver.surname;
                } else {
                  obj["Driver"] = "N/A";
                }
                this.excel_data.push(obj);
              });
            }
            this.excel_title = "vehicle-safe-list";
          }
          if (type == "vehicleunsafe") {
            if (this.DashboardReportData.VehicleUnSafeArr.length > 0) {
              this.DashboardReportData.VehicleUnSafeArr.forEach((element) => {
                var obj = {};
                obj["Vehicle"] = element.vrm;
                if (element?.driver?.driver?.forename) {
                  obj["Driver"] =
                    element.driver.driver.forename +
                    " " +
                    element.driver.driver.surname;
                }
                if (element.driver_name) {
                  obj["Driver"] = element.driver_name;
                }
                if (!element.driver_name && !element.driver) {
                  obj["Driver"] = "N/A";
                }
                obj["Reason"] = element.unsafe_reason;
                this.excel_data.push(obj);
              });
            }
            this.excel_title = "vehicle-unsafe-list";
          }
          if (type == "vehiclewarning") {
            if (this.DashboardReportData.VehicleWarningArr.length > 0) {
              this.DashboardReportData.VehicleWarningArr.forEach((element) => {
                var obj = {};
                obj["Vehicle"] = element.vrm;
                if (element?.driver?.driver?.forename) {
                  obj["Driver"] =
                    element.driver.driver.forename +
                    " " +
                    element.driver.driver.surname;
                } else {
                  obj["Driver"] = "N/A";
                }
                this.excel_data.push(obj);
              });
            }
            this.excel_title = "vehicle-warning-list";
          }
          if (type == "driverfit") {
            if (this.DashboardReportData.FitDriverArr.length > 0) {
              this.DashboardReportData.FitDriverArr.forEach((element) => {
                var obj = {};
                obj["Driver"] = element.forename + " " + element.surname;
                this.excel_data.push(obj);
              });
            }
            this.excel_title = "driver-fit-list";
          }
          if (type == "driverunfit") {
            if (this.DashboardReportData.UnfitDriverArr.length > 0) {
              this.DashboardReportData.UnfitDriverArr.forEach((element) => {
                var obj = {};
                obj["Driver"] = element.forename + " " + element.surname;
                obj["Reason"] = element.unfit_reason;
                this.excel_data.push(obj);
              });
            }
            this.excel_title = "driver-unfit-list";
          }
          if (type == "assetsafe") {
            if (this.DashboardReportData.AssetSafeArr.length > 0) {
              this.DashboardReportData.AssetSafeArr.forEach((element) => {
                var obj = {};
                obj["Asset"] = element.vrm;                
                obj["Make_Model"] = element.make + " " + element.model;                
                this.excel_data.push(obj);
              });
            }
            this.excel_title = "asset-safe-list";
          }
          if (type == "assetunsafe") {
            if (this.DashboardReportData.AssetUnSafeArr.length > 0) {
              this.DashboardReportData.AssetUnSafeArr.forEach((element) => {
                var obj = {};
                obj["Asset"] = element.vrm;               
                if (element.driver_name) {
                  obj["Driver"] = element.driver_name;
                }
                if (!element.driver_name && !element.driver) {
                  obj["Driver"] = "N/A";
                }
                obj["Reason"] = element.unsafe_reason;
                this.excel_data.push(obj);
              });
            }
            this.excel_title = "asset-unsafe-list";
          }
          if (type == "assetwarning") {
            if (this.DashboardReportData.AssetWarningArr.length > 0) {
              this.DashboardReportData.AssetWarningArr.forEach((element) => {
                var obj = {};
                obj["Asset"] = element.vrm;
                if (element.driver_name) {
                  obj["Driver"] = element.driver_name;
                }
                if (!element.driver_name && !element.driver) {
                  obj["Driver"] = "N/A";
                }
                this.excel_data.push(obj);
              });
            }
            this.excel_title = "warning-asset-list";
          }
        }
      });
    },
    ShowDashboardDetail(type) {
      this.vehiclesafeList = false;
      this.vehiclewarningList = false;
      this.vehicleunsafeList = false;
      this.driverfitList = false;
      this.driverunfitList = false;

      if (type == "vehiclewarning") {
        this.DashboardDetailHeading = "Warning Vehicle List";
        this.vehiclewarningList = true;
        this.GetUpcomingEventList("vehiclewarning");
      }
      this.ShowDashboardDetailPopup = true;
    },
    updateBoxTile(title) {
      this.InspectionsChecksHeader = title;
      this.LastOneMonthInspections = [];
      if (title == "Vehicle Inspection Stats") {
        //this.GetLastOneMonthInspectionsList();
      }
    },
    ShowVehiclePosition() {
      this.locationMarkers = [];
      this.showSimpleVehicleList = true;
      this.showSimpleAssetList = true;
      Axios.post(Endpoints.Vehicle.GetInseegoVehiclePositionAll, {
        token: localStorage.getItem("token"),
      }).then((Response) => {
        if (Response?.data?.success) {
          this.lastUpdatedPosition = Response.data.lastUpdateTime;
          this.LastVehiclePosition = Response.data.LastVehiclePosition;
          if (this.LastVehiclePosition.length > 0) {
            this.LastVehiclePosition.forEach((element) => {
              	var obj = {};
              	if(element.type=='asset'){
              		obj["NAME"] = element.vrm;
              		obj["STATUS"] = element.LastPosition.StatusText;
		        	this.location_asset_excel_data.push(obj);              		
		        }else{
		        	obj["VRM"] = element.vrm;
		            if (element?.driver?.driver?.forename) {
		                obj["Driver"] =
		                  element.driver.driver.forename +
		                  " " +
		                  element.driver.driver.surname;
		            } else {
		                obj["Driver"] = "-";
		            }
		            obj["STATUS"] = element.LastPosition.StatusText;

		            this.location_vehicle_excel_data.push(obj);
		        }    
            });            

            if(this.location_vehicle_excel_data.length>0){
            	this.showSimpleVehicleList=false;
            }

            if(this.location_asset_excel_data.length>0){
            	this.showSimpleAssetList=false;
            }

            if(this.showSimpleVehicleList){
            	this.GetVehiclesList();
            }
            if(this.showSimpleAssetList){
            	this.GetAssetsList();
            }

            Object.keys(Response.data.LastVehiclePosition).forEach(
              (element, index) => {
                var element = Response.data.LastVehiclePosition[index];
                // 🚨 Skip if LastPosition is missing
                if (!element?.LastPosition || element.LastPosition.Latitude === null || element.LastPosition.Latitude === undefined || element.LastPosition.Longitude === null || element.LastPosition.Longitude === undefined) {
                  return;
                }

                const marker = {
                  lat: element.LastPosition.Latitude,
                  lng: element.LastPosition.Longitude,
                };
                if (index == 0) {
                  this.center = marker;
                }                
                var title=element.vrm;
                var driver='';
                if(element?.driver?.driver?.forename){                	                	
                	//title =element?.driver?.driver?.forename+' '+element?.driver?.driver?.surname;
                	driver =element?.driver?.driver?.forename+' '+element?.driver?.driver?.surname;
                }
                /*if(element.LastPosition.StatusText){                	                	
                	title +=', '+element.LastPosition.StatusText;                	
                }*/
                this.locationMarkers.push({
                  position: marker,
                  title: title,
                  titleMain: element.vrm,
                  driver: driver,
                  status: element.LastPosition?.StatusText,
                  location: element.LastPosition?.Location,
                  label: { text: title, className: "map-label" },
                });                
              }
            );            
            
            if (this.$route.name == "home") {
              clearTimeout(IntervalVar)
              IntervalVar = setTimeout(() => {
                this.ShowVehiclePosition();
              }, 2 * 1000 * 60);
            }
          } else {
            this.showSimpleVehicleList = true;
            this.showSimpleAssetList = true;
            this.GetVehiclesList();
            this.GetAssetsList();
          }
        } else {
          this.showSimpleVehicleList = true;
          this.showSimpleAssetList = true;
          this.GetVehiclesList();
          this.GetAssetsList();
        }
      });
    },
    togglePositionInfo: function (marker, idx) { 
      console.log(marker)	   	
      this.infoPosition = marker.position;      
      this.infoOptions.content =
        '<div id="mapcontent"><h1 id="firstHeading" class="firstHeading" style="margin: 0px;">' +
        marker.titleMain +
        '</h1>';
        if(marker.driver){
        	this.infoOptions.content +='<h4 style="margin: 5px 0px;">Driver: '+marker.driver +'</h4>';
        }
        if(marker.status){
        	this.infoOptions.content +='<h4 style="margin: 5px 0px;">Status: '+marker.status +'</h4>';
        }       

	    if(marker.location==""){
      	Axios.get('https://maps.googleapis.com/maps/api/geocode/json?latlng='+marker.position.lat+','+marker.position.lng+'&key='+googleMapApiKey).then((Response) => {        			
        			if(Response.data && Response.data.results && Response.data.results[0]){        				
        				this.infoOptions.content +='<div id="bodyContent"><p>' + Response.data.results[0]['formatted_address'] +"</p></div></div>";
        			}
        		}) 
      	}else{
      		this.infoOptions.content +='<div id="bodyContent"><p>' + marker.location +"</p></div></div>";
      	}

      //check if its the same marker that was selected if yes toggle
      if (this.infoCurrentKey == idx) {
        this.infoOpened = !this.infoOpened;
      } else {
        this.infoOpened = true;
        this.infoCurrentKey = idx;
      }
    },
    ShowVehiclePositionPopup(vehicle) {    	
      this.ShowVehiclePositionModel = true;
      setTimeout(() => {
      	if(vehicle.type=='asset'){
        	this.$refs.VehicleMaps.SetAssetsId(vehicle.id);
        }else{
        	this.$refs.VehicleMaps.SetVehicleId(vehicle.id);
        }	
        this.$refs.VehicleMaps.ShowVehicleMaps();
      }, 500);
    },
  },
};
</script>
<style type="text/css" scoped>
.btnDisabled:disabled{
  background-color: #DDD !important;
}
</style>
<style type="text/css">

.globeicon1 {
  font-size: 26px;
  margin-top: -7px;
  cursor: pointer;
  float: left;
}
.t-cappital {
  text-transform: capitalize;
}
table.driverview td,
table.vehicleview td {
  padding: 5px;
}
.RecentFails td {
  vertical-align: top !important;
  padding-top: 5px !important;
  font-weight: normal !important;
}
/* calender css */
#DateCalenderEventDayWise {
  background-color: rgba(0, 0, 0, 0.5);
}
.eventcalenderdiv .header {
  background: #524b71;
  color: #fff;
  border-radius: 5px 5px 0 0;
}
.eventcalenderdiv .left-arrow,
.eventcalenderdiv .right-arrow {
  background: #fff;
  color: #000;
  padding: 0px 7px;
  border-radius: 50%;
}
.eventcalenderdiv .container.calendar {
  border-radius: 7px;
  padding: 0px;
}
.eventcalenderdiv .body {
  border: 3px solid #ddd;
  border-top: 0px;
  border-radius: 0 0 5px 5px;
}
#sweetCalendar .container .body .day-container .day.today,
#sweetCalendar .container .body .day-container .day.today.off-day {
  background-color: #8f4f88;
  font-weight: 700;
  border: none !important;
  color: #fff !important;
}
#sweetCalendar > .container {
  grid-template-rows: 60px 1fr !important;
}
#sweetCalendar .container .body {
  padding-top: 8px;
  padding-bottom: 10px;
  grid-row-gap: 10px !important;
}
#sweetCalendar .container .body .day-container .before,
#sweetCalendar .container .body .day-container .after {
  display: none !important;
  height: 0px !important;
}
/* end calender css */

.viewdrivervehicle .tabbed-card ul,
.inspections-checks .tabbed-card ul {
  top: 15px !important;
}
.inspections-checks .card-header h5 {
  font-size: 20px !important;
}
.vehiclesubtext {
  white-space: nowrap;
  width: 225px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.recent-vehicle table th {
  padding: 0px 10px 20px 10px !important;
  font-size: 13px !important;
}
.table td {
  padding-left: 0px !important;
}
.viewdrivervehicle .position-relative {
  position: relative;
}
.viewdrivervehicle .search-icon {
  position: absolute;
  top: 7px;
  right: 7px;
}
/* .inspections-checks .nav-pills {
  display: none;
} */
.dashboard-page .col-8 {
  max-width: 63% !important;
  padding: 4px 1px !important;
}
@media (min-width: 1280px) and (max-width: 1680px) {
  .dashboard-page .col-8 {
    max-width: 95% !important;
    padding: 4px 1px !important;
  }
}
@media screen and (max-width: 991px) {
  .viewdrivervehicle .tabbed-card ul,
  .inspections-checks .tabbed-card ul {
    top: 0 !important;
  }
}
#vehicle-inspections .modal-header {
  border: 0px !important;
  text-align: center !important;
  padding-bottom: 0px !important;
}
#vehicle-inspections .modal-title {
  text-align: center;
  width: 100%;
}
.select-vrm {
  width: 150px;
}
.search-vrm-box {
  margin-top: -44px;
  margin-left: -17px;
}
.search-vrm-box select {
  font-size: 13px;
}
.p-r-0 {
  padding-right: 0px !important;
}
.p-l-0 {
  padding-left: 0px !important;
}
.swiper-button-prev {
  color: #4433ff !important;
  z-index: 1 !important;
  left: 28px !important;
}
.swiper-button-next {
  color: #4433ff !important;
  z-index: 1 !important;
  right: 28px !important;
}
.set-position {
  position: relative;
  overflow: hidden;
}
.vehicle-slider-card {
  text-align: center;
  height: 173px;
  padding-top: 25px;
}
.homepage-swiper {
  padding: 0px !important;
  border-radius: 15px;
}
.cursor-pointer {
  cursor: pointer;
}
.vehicle-card-margin {
  margin: -19px;
}
.inspection-margin-bottom {
  margin-bottom: -20px !important;
}
.no-inspection-div {
  text-align: center;
  height: 322px;
  padding: 30px;
  font-size: 16px;
}
.hide-arrow {
  display: none;
}
.rectificationlist th {
  padding: 0.5rem !important;
}
.map-label {
  color: #41a95d !important;
  background: #fff;
  border-radius: 3px;
  margin-top: -35px;
  padding: 0px 3px;
  font-weight: bold;
  font-size: 12px;
}
.display-inline {
  display: inline-block !important;
}
.modal-footer {
  text-align: right !important;
}
.download-btn {
  float: left !important;
  padding: 10px 10px !important;
  margin-right: 10px;
}
.driver-search {
  width: 90% !important;
}
.export-unchecked-vehicle-btn{
  display: inline-block;
  margin-right: 10px;
  vertical-align: middle;
}

@media only screen and (min-width: 1068px) and (max-width: 1380px) {
  .driver-search {
    width: 85% !important;
  }
}
</style>
